import React from "react"
import Page from "../../../layout/page/Page"
import CalloutComponent from "../../../layout/error/CalloutComponent"


function withUserRequiredAuth(Wrapped) {
  return (props) => {
    const { user } = props
    if (!user) {
      return (<Page>
        <CalloutComponent title={"You must sign in first"}/>
      </Page>)
    }
    return <Wrapped {...props}  />
  }
}


withUserRequiredAuth.propTypes = {}
withUserRequiredAuth.defaultProps = {}

export default withUserRequiredAuth